import React from 'react';

function AdmissionsCTA() {
  return (
    <section id="admissions" style={{ paddingTop: '0' }}>
      <div className="wrap">
        <div className="cta-banner reveal">
          <div>
            <h2>{'Every child has a talent waiting to grow.'}</h2>
            <p>
              {'Classroom learning, practical studies and creative opportunities help our students build confidence for the future.'}
            </p>
          </div>
          <div className="cta-actions">
            <a href="#academics" className="btn primary">
              {'Explore Academics'}
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
              >
                <path d="M5 12h14M13 6l6 6-6 6"></path>
              </svg>
            </a>
            <a href="#campus" className="btn ghost">
              {'Explore Campus Life'}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AdmissionsCTA;
